export enum CaseStyle {
    Camel = 'Camel',
    Pascal = 'Pascal',
}
